export const uk = {
    apply: 'Использовать',
    create: 'создать',
    'create-from-preset': 'Создать на основе',
    'creative-remove-confirm-description': 'Вы действительно хотите удалить набор баннеров?',
    edit: 'Изменить',
    'no-creatives': 'Нет креативов',
    'no-creatives-but-can-create': 'Здесь пока пусто, самое время что-нибудь {presetsLink}',
    select: 'Выбрать',
    selected: 'Выбрано {selected} из {total}',
    'selected-banner-sizes': 'Показаны креативы с баннерами размеров: {sizes} ',
    view: 'Посмотреть'
};
